export const MOBILE_ACTIVITY_MENU_HEIGHT = 12;
